// extracted by mini-css-extract-plugin
module.exports = {"searchInfoContainer":"_2CFAHrvb3xGod7B8mDCmOL"};